module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-consumable-item-input"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.name')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.name),
      expression: "consumableItem.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.name = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.name),
      expression: "!validation.name"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.name'))), _c('br'), _vm._v(_vm._s(_vm.$t('consumableItem.label.kana')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.name_hurigana),
      expression: "consumableItem.name_hurigana"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.name_hurigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.name_hurigana = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.name_hurigana),
      expression: "!validation.name_hurigana"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_furigana')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.code')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.product_code),
      expression: "consumableItem.product_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.product_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.product_code = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.product_code),
      expression: "!validation.product_code"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.category')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.category_id),
      expression: "consumableItem.category_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.consumableItem.category_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.categories), function(category, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.name))])
  })), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.category_id),
      expression: "!validation.category_id"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.supplier')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.supplier_id),
      expression: "consumableItem.supplier_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.consumableItem.supplier_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.suppliers), function(supplier, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": supplier.id
      }
    }, [_vm._v(_vm._s(supplier.name))])
  })), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.supplier_id),
      expression: "!validation.supplier_id"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.unit')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.unit),
      expression: "consumableItem.unit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.unit = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.unit),
      expression: "!validation.unit"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.size')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.size),
      expression: "consumableItem.size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.size = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.1 lot per'))), _c('br'), _vm._v(_vm._s(_vm.$t('consumableItem.label.quantity')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.lot_number),
      expression: "consumableItem.lot_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.lot_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.lot_number = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("/1ロット")])])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.lot_number),
      expression: "!validation.lot_number"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.1 lot per'))), _c('br'), _vm._v(_vm._s(_vm.$t('consumableItem.label.price')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.lot_price),
      expression: "consumableItem.lot_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.lot_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.lot_price = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('label', {
    staticClass: "col-sm-2"
  }, [_vm._v("円")])])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.lot_price),
      expression: "!validation.lot_price"
    }],
    staticClass: "validation-msg text-left"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('consumableItem.label.order reception')))]), _c('div', {
    staticClass: "col-sm-10",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.is_can_order),
      expression: "consumableItem.is_can_order"
    }],
    attrs: {
      "type": "radio",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.consumableItem.is_can_order, "true")
    },
    on: {
      "click": function($event) {
        _vm.consumableItem.is_can_order = "true"
      }
    }
  }), _c('span', [_vm._v("受付中")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.is_can_order),
      expression: "consumableItem.is_can_order"
    }],
    attrs: {
      "type": "radio",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.consumableItem.is_can_order, "false")
    },
    on: {
      "click": function($event) {
        _vm.consumableItem.is_can_order = "false"
      }
    }
  }), _c('span', [_vm._v("発注不可")])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("備考")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItem.remark),
      expression: "consumableItem.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "255",
      "rows": "6"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItem.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItem.remark = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "row margin-top",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger margin-right",
    on: {
      "click": function($event) {
        _vm.$router.push('/master_consumable_item_list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v("キャンセル")])]), (_vm.isStockCheckPeriod) ? _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validationAll
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#not_reflection_warning_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v("保存")])]) : _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validationAll
    },
    on: {
      "click": function($event) {
        _vm.sendData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v("保存")])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "not_reflection_warning_modal",
      "role": "dialog",
      "data-backdrop": "static",
      "aria-labelledby": "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("注意事項")])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "col-sm-9 margin-top",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#send_modal"
    },
    on: {
      "click": function($event) {
        _vm.sendData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Confirmed Message')))]), _c('button', {
    staticClass: "btn btn-info margin-left",
    attrs: {
      "data-dismiss": "modal",
      "rightmargin": "30"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("現在店舗で残取り中のデータに変更は反映されません。現在の残取り作業に影響のある変更の場合、店舗へ直接ご連絡ください。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d2a8c2b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-consumable-item-input.pug
// module id = 770
// module chunks = 1